export default __webpack_public_path__ + "static/media/icon_red_farmacias_off.2f72f4eb.svg";